const filterBooleanConstants = {
	doNotCarryOutOfSeason: 'doNotCarryOutOfSeason',
	repurchase: 'repurchase',
	purchasingOnly: 'purchasingOnly',
};

export { filterBooleanConstants };



// WEBPACK FOOTER //
// ./src/common/constants/filterBooleanConstants.js